const setCustomerName = (name: string) => ({
  type: 'SET_CUSTOMER_NAME',
  name,
})

export default setCustomerName
